import { render } from "./editor.vue?vue&type=template&id=62d7b46f"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/shared/editor/editor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62d7b46f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62d7b46f', __exports__)) {
    console.log('reload')
    api.reload('62d7b46f', __exports__)
  }
  
  module.hot.accept("./editor.vue?vue&type=template&id=62d7b46f", () => {
    console.log('re-render')
    api.rerender('62d7b46f', render)
  })

}


export default __exports__